import {registeredUser} from "../registration/registeredUser";
import {organizationStore} from "../organizations/organizations";
import {userStore} from "../users/users";
import {get} from 'svelte/store'

export async function getQuote() {
    const data = {
        applicant: get(registeredUser),
        organizations: get(organizationStore),
        users: get(userStore)
    }
    const response = await fetch('/api/ehrequests/quote', {
        method: 'POST',
        referrer: '',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
    return await response.json()
}